import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { getActiveBlogs } from "../../store/actions/blog";
import PageTitle from "../../components/shared/PageTitle";
import CategoriesWidget from "../../components/shared/CategoriesWidget";
import CartWidget from "../../components/shared/CartWidget";
import SEO from "../../components/shared/SEO";
import Loading from "../../components/shared/Loading";
import { PUBLIC_URL } from "../../config";

class Blog extends Component {
  componentDidMount() {
    this.props.getActiveBlogs();
    window.scrollTo(0, 0);
  }

  formatDate(dateStr) {
    if (!dateStr) return "";
    var date = new Date(dateStr);
    var months = [
      "Ocak", "Subat", "Mart", "Nisan", "Mayis", "Haziran",
      "Temmuz", "Agustos", "Eylul", "Ekim", "Kasim", "Aralik"
    ];
    return date.getDate() + " " + months[date.getMonth()] + " " + date.getFullYear();
  }

  render() {
    var blogs = this.props.blog.blogs || [];
    var fetching = this.props.blog.fetching;

    return (
      <React.Fragment>
        <SEO
          title="Blog - Botaniksan"
          description="Botaniksan blog yazilari. Bitki bakimi, peyzaj ve bahcecilik hakkinda faydali bilgiler."
          url="/blog"
        />
        <PageTitle title="Blog" />
        <div className="row">
          <div className="container">
            <div className="row">
              <div className="col-md-9">
                <div className="row" style={{ marginTop: 20, marginBottom: 50 }}>
                  {fetching ? (
                    <div style={{ width: "100%", textAlign: "center", padding: "40px 0" }}>
                      <Loading />
                    </div>
                  ) : blogs.length === 0 ? (
                    <div style={{ width: "100%", textAlign: "center", padding: "40px 0" }}>
                      <p>Henuz blog yazisi bulunmamaktadir.</p>
                    </div>
                  ) : (
                    blogs.map(function(blog) {
                      return (
                        <div key={blog.id} className="col-md-6" style={{ marginBottom: 30 }}>
                          <div className="card h-100" style={{ border: "1px solid #eee", borderRadius: 8, overflow: "hidden", boxShadow: "0 2px 8px rgba(0,0,0,0.08)" }}>
                            <Link to={"/blog/" + blog.slug}>
                              {blog.image ? (
                                <img
                                  src={PUBLIC_URL(blog.image)}
                                  alt={blog.title}
                                  style={{ width: "100%", height: 200, objectFit: "cover" }}
                                />
                              ) : (
                                <div style={{ width: "100%", height: 200, backgroundColor: "#f5f5f5", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                  <i className="fas fa-image" style={{ fontSize: 48, color: "#ccc" }}></i>
                                </div>
                              )}
                            </Link>
                            <div className="card-body" style={{ padding: 20 }}>
                              <small style={{ color: "#999" }}>{this.formatDate(blog.created_at)}</small>
                              <h5 style={{ marginTop: 8, marginBottom: 10 }}>
                                <Link to={"/blog/" + blog.slug} style={{ color: "#333", textDecoration: "none" }}>
                                  {blog.title}
                                </Link>
                              </h5>
                              <p style={{ color: "#666", fontSize: 14, lineHeight: 1.6 }}>
                                {blog.summary && blog.summary.length > 120
                                  ? blog.summary.substring(0, 120) + "..."
                                  : blog.summary}
                              </p>
                              <Link
                                to={"/blog/" + blog.slug}
                                style={{ color: "#28a745", fontWeight: 600, fontSize: 14, textDecoration: "none" }}
                              >
                                Devamini Oku &rarr;
                              </Link>
                            </div>
                          </div>
                        </div>
                      );
                    }.bind(this))
                  )}
                </div>
              </div>
              <div className="col-md-3">
                <CartWidget />
                <CategoriesWidget />
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

var mapStateToProps = function(state) {
  return { blog: state.blog };
};
var mapDispatchToProps = { getActiveBlogs: getActiveBlogs };

export default connect(mapStateToProps, mapDispatchToProps)(Blog);



// WEBPACK FOOTER //
// ./src/routers/Blog/index.js